<template>
    <form class="custom-input-group"
        @submit.prevent="goSearchUnit">
        <div class="form-obj-flex">
            <div class="form-flex-area obj">
                <input type="text"
                    v-model="unitname"
                    class="form-control"
                    :placeholder="placeholder()"
                    autocomplete="off">

            </div>
        </div>
        <div class="form-btn">
            <div class="searchbox-obj">
                <button class="btn btn-primary"
                    type="submit"
                    tabindex="0"
                    :aria-label="buttonLabel()">
                    <i class="fa-sharp fa-light fa-search"
                        aria-hidden="true"></i>
                    <span class="sr-only">{{voMsg('tpl.search.btn.search')}}</span>
                </button>
            </div>
        </div>
    </form>

</template>
<script>
    import {
    	isBlank
    }
    from 'voUtils/tools.js';
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';


    import {
    	doReq
    }
    from 'voUtils/RestEx.js';

    export default {

    	voVueComponent: 'search-unit-name',

    	data: function() {
    		return {
    			unitname: ''
    		}
    	},

    	methods: {
    		placeholder: function() {
    			return this.voMsg('tpl.search.filter.nameorid');
    		},
    		buttonLabel: function() {
    			return this.voMsg("tpl.search.btn.search");
    		},
    		goSearchUnit: function() {
    			if (isBlank(this.unitname)) {
    				window.location.href = 's';
    			} else {
    				var req = {
    					fields: {
    						"u.path": {
    							"filter": "vlang"
    						}
    					},
    					filter: {
    						name: this.unitname
    					},
    					sorting: 'random',
    				};

    				doReq('searchUnits', req)
    					.then((res) => {

    						window.location.href = 's#?name=' + encodeURIComponent(this.unitname);

    					});
    			}

    		}
    	}

    }
</script>